import {
    buyCourse,
    buyLesson,
    checkCourseOrder,
    checkLessonOrder,
    checkQaOrder,
    buyQa,
} from '@/services/detail';
import yoda from '@/yoda';
import { compareVersionByOs } from '@/utils/env';
import { kwaiAppVersion } from '@/constant';
import { kpn } from '@/utils/env';

/**
 * 支付宝、微信、快币购买问答
 * @param {*} param0
 */
export const payForQa = ({ professionId, questionId, channel = '', useKscoinPay = false }) => {
    return new Promise((resolve, reject) => {
        let orderId = 0;
        const onMessageHandler = res => {
            if (res.data.messageType === 'ksBridge.startKspayOrderPrepay') {
                if (res.data.messageStatus === 'complete') {
                    resolve({ ...res.data.ret, orderId });
                } else {
                    reject(res.data.ret);
                }
                window.removeEventListener('message', onMessageHandler, false);
            } else if (res.data.messageType === 'func.getServerExpTag') {
                const expTag = res.data.ret ?? {};
                buyQa(professionId, questionId, channel, useKscoinPay, expTag).then((res: any) => {
                    if (res.result === 1) {
                        if (res.pay_client_type === 1) {
                            const { merchant_id, out_order_no, order_id } = res.new_pay_data;
                            //  跳转页面需要out_order_no ，先挂载window上
                            window.out_order_no = out_order_no;
                            orderId = order_id;
                            window.parent.postMessage(
                                {
                                    messageType: 'ksBridge.startKspayOrderPrepay',
                                    params: {
                                        merchantId: merchant_id,
                                        outOrderNo: out_order_no,
                                    },
                                },
                                '*',
                            );
                        }
                    } else {
                        reject(res);
                    }
                });
            }
        };
        window.addEventListener('message', onMessageHandler, false);
        window.parent.postMessage(
            {
                messageType: 'func.getServerExpTag',
            },
            '*',
        );
    });
};

/**
 * 支付宝、微信、快币购买course
 * @param {*} param0
 */
export const payForCourse = ({
    courseId,
    dc = '',
    channel = '',
    useKscoinPay = false,
    commodityId = '',
    expireTime = '',
    voucherList = [],
    price = 0,
    courseDistributionId,
    activityInfo,
    giftAddressId,
    remark,
}) => {
    return new Promise((resolve, reject) => {
        buyCourse(
            courseId,
            dc,
            channel,
            useKscoinPay,
            commodityId,
            expireTime,
            voucherList,
            courseDistributionId,
            activityInfo,
            giftAddressId,
            remark,
        ).then((res: any) => {
            if (res.result === 1) {
                if (price === 0) {
                    resolve({
                        result: 1,
                        error_msg: '',
                    });
                    // Log: 优惠券购买课程成功
                    if (yoda.isInYoda) {
                        window.ksLog?.sendCountTag('Lightks_BuyCourse_Ticket_Success');
                    }
                } else if (res.pay_client_type === 1) {
                    const { merchant_id, out_order_no } = res.new_pay_data;
                    window.out_order_no = out_order_no;
                    // 新版支付中台，人民币会拉起支付宝/微信的支付窗口
                    yoda(
                        'kwai',
                        'startKspayOrderPrepay',
                        {
                            merchantId: merchant_id,
                            outOrderNo: out_order_no,
                        },
                        res => {
                            if (res.result == 1) {
                                resolve(res);
                            }
                            reject(res);
                        },
                    );
                } else {
                    yoda('kwai', 'startGatewayPay', { data: res.data }, res => {
                        if (res.result === 1) {
                            resolve(res);
                        }
                        reject(res);
                    });
                }
            } else {
                reject(res);
            }
        });
    });
};

/**
 * 支付宝、微信、快币购买lesson
 * @param {*} param0
 */
export const payForLesson = ({
    lessonId,
    dc = '',
    channel = '',
    useKscoinPay = false,
    commodityId = '',
    expireTime = '',
    price,
    voucherList = [],
    courseDistributionId,
}) => {
    return new Promise((resolve, reject) => {
        buyLesson(
            lessonId,
            dc,
            channel,
            useKscoinPay,
            commodityId,
            expireTime,
            voucherList,
            courseDistributionId,
        ).then((res: any) => {
            if (res.result === 1) {
                if (price === 0) {
                    resolve({
                        result: 1,
                        error_msg: '',
                    });
                    // Log: 优惠券购买课程成功
                    // TODO: 新版优惠券的埋点？？
                    if (yoda.isInYoda) {
                        window.ksLog?.sendCountTag('Lightks_BuyLesson_Ticket_Success');
                    }
                } else if (res.pay_client_type === 1) {
                    const { merchant_id, out_order_no } = res.new_pay_data;
                    window.out_order_no = out_order_no;
                    // 新版支付中台，人民币会拉起支付宝/微信的支付窗口
                    yoda(
                        'kwai',
                        'startKspayOrderPrepay',
                        {
                            merchantId: merchant_id,
                            outOrderNo: out_order_no,
                        },
                        res => {
                            res.result === 1 ? resolve(res) : reject(res);
                        },
                    );
                } else {
                    yoda(
                        'kwai',
                        'startGatewayPay',
                        {
                            data: res.data,
                        },
                        res => {
                            res.result === 1 ? resolve(res) : reject(res);
                        },
                    );
                }
            } else {
                reject(res);
            }
        });
    });
};

/**
 * 轮询检查qaOrder是否购买 每过一秒请求一次
 * @param {Number} courseId
 * @param {Number} times
 */
export const checkPayQa = async (orderId, times = 0) => {
    const res = await checkQaOrder({
        orderId,
        attemptedTimes: times,
    });
    times++;
    if (res.result === 1) {
        return res;
    }
    if (res.result === 101) {
        return new Promise(resolve => {
            setTimeout(() => resolve(checkPayQa(orderId, times)), 1000);
        });
    }
    throw new Error(res.error_msg);
};

/**
 * 轮询检查course是否购买 每过一秒请求一次
 * @param {Number} courseId
 * @param {Number} times
 */
export const checkPayCourse = async (courseId, times = 0) => {
    const res = await checkCourseOrder({
        courseId,
        attemptedTimes: times,
    });
    times++;
    if (res.result === 1) {
        return res;
    }
    if (res.result === 101) {
        return new Promise(resolve => {
            setTimeout(() => resolve(checkPayCourse(courseId, times)), 1000);
        });
    }
    throw new Error(res.error_msg);
};

/**
 * 轮询检查lesson是否购买 每过一秒请求一次
 * @param {Number} lessonId
 * @param {Number} times
 */
export const checkPayLesson = async (lessonId, times = 0) => {
    const res = await checkLessonOrder({
        lessonId,
        attemptedTimes: times,
    });
    times++;
    if (res.result === 1) {
        return res;
    }
    if (res.result === 101) {
        return new Promise(resolve => {
            setTimeout(() => resolve(checkPayLesson(lessonId, times)), 1000);
        });
    }
    throw new Error(res.error_msg || '系统错误');
};

export const setSettingEntryForCourse = params => {
    const compareV = compareVersionByOs(kwaiAppVersion[kpn].allowSettingEntry);
    if (compareV <= 0) {
        yoda('kwai', 'setSettingEntryForCourse', { show: true, ...params });
    }
};
